export default __webpack_public_path__ + "images/destinations/webex.png";